export const environment: {
  ELITE_BASE_URI: string;
  RECAPTCHA_KEY: string;
} = {
  //// PROD
  // ELITE_BASE_URI: 'https://bithotel.bitgenius.it/api',
  //// TEST
  ELITE_BASE_URI: 'https://bithoteltest.centropaghe.it/api',
  //// DEMO
  // ELITE_BASE_URI: 'https://bithoteldemo.bitgenius.it/api',
  //// DEV
  // ELITE_BASE_URI: "https://localhost:7150/api",
  RECAPTCHA_KEY: "6LdKQqktAAAAAEFy13PD8tgMM_PYFcrbIMIXK52M",
};
